export default __webpack_public_path__ + "static/media/05.b7a6230a.mp3";